import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const { VITE_COMPANION_APP_URL } = import.meta.env

interface MessageData {
  type: string
  url: string
}

function OnboardingCallback() {
  const location = useLocation()
  useEffect(() => {
    const url = new URL(
      `${VITE_COMPANION_APP_URL}${window.location.search}&redirect_uri=${window.location.origin}/onboardingcallback`,
    )
    const messageData: MessageData = {
      type: 'externalLogin',
      url: url.href,
    }

    if (window.self !== window.top) {
      document.body.classList.add('!bg-transparent')
      window.parent.postMessage(messageData, '*')
    } else {
      window.location.href = url.href
      console.log('Redirecting to:', url.href)
    }
  }, [location.pathname])

  return null
}

export { OnboardingCallback }
